import { Component, signal } from '@angular/core';

import { RouterLink } from '@angular/router';
import { AuiIconComponent } from '@ral/ui:aui/icons';
import { StoryCardComponent } from '@storyteller/card';
import { StoryContainerComponent } from '@storyteller/container';
import { StoryDescriptionComponent } from '@storyteller/description';
import { StoryFeatureComponent } from '@storyteller/feature';
import { StoryImageComponent, StoryImageSourceComponent } from '@storyteller/image';
import { StoryTitleComponent } from '@storyteller/title';
import { EasyLeanKitComponent } from '../components';
import { AcpSystemComponent } from '../components/acp-system.component';
import { InquiryComponent, InquiryItemComponent } from '../components/inquiry.component';
import { MillBarFeederComponent } from '../components/mill-bar-feeder.component';
import { AppSimplyCarouselComponent } from '../components/simply-carousel.component';
import { AuiItemComponent } from '@ral/ui:aui/item';

@Component({
    selector: 'app-antbot-pro-cnc-page',
    imports: [
        StoryContainerComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
        StoryImageComponent,
        AuiItemComponent,
        InquiryComponent,
        MillBarFeederComponent,
        MillBarFeederComponent,
        AcpSystemComponent,
        AcpSystemComponent,
        StoryFeatureComponent,
        InquiryItemComponent,
        AuiIconComponent,
        RouterLink,
        StoryImageSourceComponent,
        EasyLeanKitComponent,
        AppSimplyCarouselComponent,
        StoryCardComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
        AuiIconComponent,
    ],
    template: `
        <header>
            <story-container
                [space]="'py-[20px] w500:py-[40px] md:py-[70px] lg:py-[100px]'"
                [skipTopPadding]="true"
                [skipSmallScreenTopPadding]="true"
            >
                <div class="detail-cover gap-6 md:gap-10">
                    <div class="img-block">
                        <story-image
                            fetchPriority="high"
                            [loading]="'eager'"
                            class="block aspect-[345/435] max-w-[500px] overflow-hidden rounded sm:aspect-[500/600]"
                            aria-labelledby="antbot-pro-cnc-title"
                        >
                            <story-source
                                [src]="'assets/images/antbot-pro-cnc.jpg'"
                                [width]="500"
                                [height]="600"
                                media="(min-width: 640px)"
                            />
                            <story-source
                                [src]="'assets/images/antbot-pro-cnc.jpg'"
                                [width]="500"
                                [height]="600"
                                media="(min-width: 200px)"
                            />
                        </story-image>
                    </div>

                    <div class="title-block">
                        <div class="flex flex-col gap-2" id="antbot-pro-cnc-title">
                            <story-title [headingLevel]="1" className="story-font-headline1 pb-3 w500:pb-4"
                                >Antbot pro CNC</story-title
                            >
                            <story-description>
                                Flexibilní robotizace pro malé série a&nbsp;maximální využití CNC strojů.
                            </story-description>
                        </div>
                        <div class="flex flex-col gap-1 pb-[11px] pt-6 w460:flex-row md:gap-2 md:pt-8">
                            <div>
                                <button auiItem [size]="'40'" [color]="'primary'" (click)="openInquiryForm()">
                                    <span auiItemLabel>Zobrazit cenu</span>
                                </button>
                            </div>
                            <a auiItem [size]="'40'" [color]="'gray'" auiStyle="decent" [routerLink]="['/', 'antbot-pro-cnc']" fragment="description">
                                <span auiItemLabel>Chci více informací</span>
                            </a>
                        </div>
                    </div>
                    <div class="features-block self-end">
                        <div class="w500:grid-cols-2 grid grid-cols-1 gap-5 lg:gap-10">
                            <div>
                                <story-feature>
                                    <aui-icon icon="user-shield" class="text-[28px]" />
                                    <story-title [headingLevel]="2" className="story-font-headline3 pb-1"
                                        >Bezpečné fungování po boku člověka</story-title
                                    >
                                    <story-description>
                                        Ve dne sdílené pracoviště, v&nbsp;noci samostatný&nbsp;provoz.
                                    </story-description>
                                </story-feature>
                            </div>
                            <div>
                                <story-feature>
                                    <aui-icon icon="gauge-max" class="text-[28px]" />
                                    <story-title [headingLevel]="2" className="story-font-headline3 pb-1"
                                        >Rychlé nasazení a&nbsp;přestavení</story-title
                                    >
                                    <story-description>
                                        Nastavíte během několika minut a&nbsp;snadno přesunete mezi stanovišti.
                                    </story-description>
                                </story-feature>
                            </div>
                        </div>
                    </div>
                </div>
            </story-container>
        </header>
        <section>
            <div class="-top:5 w500:-top-12 relative">
                <div id="description" class="relative -top-12 lg:top-[-100px]"></div>
            </div>
            <story-container [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <div class="flex flex-col-reverse items-center gap-5 md:grid md:grid-cols-2 lg:gap-10">
                    <div>
                        <story-title [headingLevel]="2" className="story-font-headline2 pb-6"
                            >Produktový popis</story-title
                        >
                        <story-description class="block">
                            Antbot for CNC je nejjednodušší cesta k&nbsp;robotizaci výroby. Díky uchopovacím prstům má
                            cit pro přesné zakládání dílů. Kompaktní zástavba se vejde do každé dílny a&nbsp;příprava
                            malosériových zakázek je přehledná i&nbsp;snadno opakovatelná. Podle potřeby lze přidat
                            další funkce a&nbsp;rozšířit automatizaci, Antbot tak roste spolu s&nbsp;vašimi požadavky.
                            <br /><br />
                            Obsluha zvládne zaškolení během krátké chvíle a&nbsp;ihned začne šetřit čas při upínání
                            i&nbsp; manipulaci. Kolaborativní robot bezpečně obsluhuje CNC, efektivně zakládá
                            a&nbsp;odebírá díly a&nbsp;udržuje výrobu v&nbsp;chodu i&nbsp;přes noc. Antbot přináší vyšší
                            vytíženost strojů, lepší ekonomiku provozu a&nbsp;to bez&nbsp;složitých projektů.
                            <br /><br />
                            Vaši lidé se tak mohou věnovat hodnotnější práci, zatímco Antbot spolehlivě zvládá rutinní
                            úkoly.
                        </story-description>
                    </div>
                    <div>
                        <story-image class="aspect-[422/565] overflow-hidden rounded">
                            <story-source [src]="'assets/images/antbot-pro-cnc.png'" [width]="422" [height]="565" />
                        </story-image>
                    </div>
                </div>
            </story-container>
        </section>
        <section class="overflow-hidden">
            <story-container [space]="'w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <app-carousel
                    [slides]="[
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8375.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 1',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8388.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 2',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8499.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 3',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8558.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 4',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8417.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 5',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8440.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 6',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8569.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 7',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8481.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 8',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8451.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 9',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8543.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 10',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8453.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 11',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8529.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 12',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8562.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 13',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8362.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 14',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8478.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 15',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8564.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 16',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8570.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 17',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8469.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 18',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8551.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 19',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8510.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 20',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8537.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 21',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8555.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 22',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8487.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 23',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8533.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 24',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8442.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 25',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8490.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 26',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8518.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 27',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8450.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 28',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8455.JPG',
                            isPortrait: false,
                            alt: 'Antbot pro CNC | Fotka 29',
                        },
                        {
                            url: 'assets/images/antbot-pro-cnc/0K2A8415.JPG',
                            isPortrait: true,
                            alt: 'Antbot pro CNC | Fotka 30',
                        },
                    ]"
                ></app-carousel>
            </story-container>
        </section>
        <section>
            <story-container [space]="'pt-12 w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <story-title [headingLevel]="3" className="story-font-headline2 pb-6"
                    >Technická specifikace</story-title
                >
                <table class="w-full table-fixed text-left">
                    <thead>
                        <tr>
                            <th class="pb-2 pt-6 font-semibold">Parametr</th>
                            <th aria-label="Hodnota"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="tr">
                            <th>Typ robota</th>
                            <td>Fanuc CRX-10i</td>
                        </tr>
                        <tr class="tr">
                            <th>Nosnost robota</th>
                            <td>10&nbsp;kg</td>
                        </tr>
                        <tr class="tr">
                            <th>Dosah</th>
                            <td>Ø 2200&nbsp;mm</td>
                        </tr>
                        <tr class="tr">
                            <th>Opakovatelnost</th>
                            <td>+-0,04&nbsp;mm</td>
                        </tr>

                        <tr class="tr">
                            <th>Rychlost</th>
                            <td>250&nbsp;mm/s colab, 2000&nbsp;mm/s high speed mode</td>
                        </tr>
                        <tr class="tr">
                            <th>HMI a učení trajektorií</th>
                            <td>teaching pendant</td>
                        </tr>
                        <tr class="tr">
                            <th>Cit v zakládání</th>
                            <td>ano</td>
                        </tr>
                        <tr class="tr">
                            <th>Typ uchopovače</th>
                            <td>MTB kit Schunk</td>
                        </tr>
                        <tr class="tr">
                            <th>Síla upínání</th>
                            <td>550&nbsp;-&nbsp;610&nbsp;N</td>
                        </tr>
                        <tr class="tr">
                            <th>Detekce dílu</th>
                            <td>přítomnost</td>
                        </tr>
                        <tr class="tr">
                            <th>Takt výměny dílu</th>
                            <td>60&nbsp;s</td>
                        </tr>
                        <tr class="tr">
                            <th>Příprava nové výroby</th>
                            <td>30&nbsp;min</td>
                        </tr>
                        <tr class="tr">
                            <th>Bezpečnost</th>
                            <td>podlahový scanner + oplocení</td>
                        </tr>
                        <tr class="tr">
                            <th>Zástavbový prostor</th>
                            <td>1000&nbsp;x&nbsp;1000&nbsp;mm</td>
                        </tr>
                        <tr class="tr">
                            <th>Napětí</th>
                            <td>230&nbsp;V</td>
                        </tr>
                        <tr class="tr">
                            <th>Provozní tlak vzduchu</th>
                            <td>2,5 - 7&nbsp;bar</td>
                        </tr>
                    </tbody>
                </table>
                <h4 class="pb-2 pt-6 font-semibold">Technický popis</h4>

                <story-description class="block max-w-[740px]">
                    Požadavky na stroj zahrnují dostupné I/O rozhraní, podporu M-kódů, přístup k&nbsp;signálům dveří
                    a&nbsp;možnost rozšíření o&nbsp;Total Stop bezpečnostní okruh.
                </story-description>
            </story-container>
        </section>
        <section>
            <story-container [space]="'pt-12 w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <story-title [headingLevel]="3" className="story-font-headline2 pb-6">Ke stažení</story-title>

                <div class="flex flex-wrap gap-6 lg:gap-8">
                    <div class="min-w-[245px] max-w-[320px] flex-grow">
                        <story-card>
                            <aui-icon icon="file-pdf" class="text-[32px]" />
                            <story-title [headingLevel]="4" className="@lg:story-font-headline4 story-font-headline4"
                                >Technická specifikace</story-title
                            >
                            <story-description
                                [className]="'@lg:leading-[28px] @lg:max-w-[460px] aui-font-regular-14 leading-[1.5]'"
                            >
                                Tento soubor obsahuje rozměry a technické specifikace pro Antbot pro CNC.
                            </story-description>
                            <a
                                auiItem
                                [size]="'40'"
                                [color]="'primary'"
                                [auiStyle]="'decent'"
                                [fullWidth]="true"
                                [href]="'/assets/files/antbot-pro-cnc_tech-spec.pdf'"
                                download
                                aria-label="Stáhnout specifikaci (PDF, méně než 1 MB)"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span auiItemLabel>Stáhnout specifikaci</span>
                            </a>
                        </story-card>
                    </div>
                    <div class="min-w-[245px] max-w-[320px] flex-grow">
                        <story-card>
                            <aui-icon icon="file-pdf" class="text-[32px]" />
                            <story-title [headingLevel]="4" className="@lg:story-font-headline4 story-font-headline4"
                                >Technický výkres</story-title
                            >
                            <story-description
                                [className]="'@lg:leading-[28px] @lg:max-w-[460px] aui-font-regular-14 leading-[1.5]'"
                            >
                                Tento soubor obsahuje technický výkres pro Antbot pro CNC.
                            </story-description>
                            <a
                                [href]="'/assets/files/antbot-pro-cnc_tech-vykres.pdf'"
                                auiItem
                                [size]="'40'"
                                [color]="'primary'"
                                [auiStyle]="'decent'"
                                [fullWidth]="true"
                                download
                                aria-label="Stáhnout výkres (PDF, méně než 1 MB)"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span auiItemLabel>Stáhnout výkres</span>
                            </a>
                        </story-card>
                    </div>
                </div>
            </story-container>
        </section>
        <section>
            <story-container>
                <story-title [headingLevel]="2" className="story-font-headline1 pb-12 md:pb-16 lg:pb-20"
                    >Prohlédněte si ostatní produkty</story-title
                >
                <div class="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
                    <div>
                        <app-mill-bar-feeder></app-mill-bar-feeder>
                    </div>
                    <div>
                        <app-acp-system></app-acp-system>
                    </div>
                    <div>
                        <app-easy-lean-kit></app-easy-lean-kit>
                    </div>
                </div>
            </story-container>
        </section>

        @if (isInquiryFormOpened()) {
            <app-inquiry-form (closeInquiry)="closeInquiryForm()" [productName]="'Antbot pro CNC'">
                <app-inquiry-item productName="Antbot pro CNC" [priceWithoutVat]="1250000"></app-inquiry-item>
                <p class="story-gray-text pb-2 pr-16">
                    Součástí produktu je Antbot (cobot Fanuc CRX10), Schunk uchopovač, rozvaděč, stolek s&nbsp;rastrem
                    a&nbsp; základní sadou dorazů pro instalaci a&nbsp;umístění Antbota do výroby, návody na zapojení
                    a&nbsp;konfiguraci, 2 dny instalace a&nbsp;školení dvou pracovníků.
                </p>
                <app-inquiry-item
                    productName="Bezpečnostní kit - 3D podlahový scanner a částečné oplocení"
                    [priceWithoutVat]="150000"
                    [defaultValue]="0"
                    [allowZeroItems]="true"
                ></app-inquiry-item>
                <app-inquiry-item
                    productName="Svěrák"
                    [priceWithoutVat]="50000"
                    [defaultValue]="0"
                    [allowZeroItems]="true"
                ></app-inquiry-item>
                <app-inquiry-item
                    productName="Automatické otevírání CNC dveří"
                    [defaultValue]="0"
                    [allowZeroItems]="true"
                    [priceWithoutVat]="40000"
                ></app-inquiry-item>
                <app-inquiry-item
                    productName="Máte vlastního kobota?"
                    [defaultValue]="0"
                    [allowZeroItems]="true"
                    [priceWithoutVat]="0"
                ></app-inquiry-item>
                <p class="story-gray-text pr-16">
                    Rádi Vám pomůžeme s&nbsp;automatizací pomocí kobota, kterého už máte k&nbsp;dispozici. Odešlete nám
                    tuto poptávku a&nbsp;my vás kontaktujeme.
                </p>
            </app-inquiry-form>
        }
    `,
})
export class AntBotProCncPageComponent {
    isInquiryFormOpened = signal(false);

    openInquiryForm() {
        this.isInquiryFormOpened.set(true);
    }

    closeInquiryForm() {
        this.isInquiryFormOpened.set(false);
    }
}
